import React from "react";
import {
  Heading1,
  Heading2,
  Heading3,
  NoStyleSpan,
  Paragraph,
  F12,
  Span,
  LinkStyled,
  Bold,
  List,
  LinkButton,
} from "../../components/typography";
import { Container, Row, Col, Div } from "../../components/grid";
import { Image } from "../../components/Image";
import FadoelTable from "./FadoelTable";
import { Price, PriceSum, ColliCount, Money } from "../../containers/commerce";
import { Table, Tr, Td, Th } from "../../components/tables";
import SidemenuLayout from "../../layout/DefaultLayout/Layouts/SidemenuLayout";

export default () => (
  <SidemenuLayout menuPicker="Fadoel" activeSidemenu="Priser">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>Fadøl priser</Heading1>
          <Heading2>
            Vi har{" "}
            <NoStyleSpan underline>
              altid fadøl og ledige fadølsanlæg
            </NoStyleSpan>
            , også med kort varsel.
            <br />
            Fustager der ikke er brugt, refunderes til fuld pris minus{" "}
            <Price varenr="641" /> pr. stk.
          </Heading2>
          <Paragraph>
            Her finder du alle vores fadøl priser samt priser på fadølsanlæg.
            Hos Skafte har vi altid både fadøl og ledige anlæg på lager, så du
            er klar til din næste fest - også selvom du bestiller med kort
            varsel. Vores priser på fadølsanlæg er stærkt konkurrencedygtige og
            skulle du have uåbnede fustager tilbage efter festen, tager vi dem
            gerne retur. Få et godt overblik over alle vores fadøl priser her.
            Mangler du også et fadølsanlæg? Lej det billigt hos Skafte!
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Paragraph bold fontSize="18px">
            Tryk på overskrifterne for at sortere listen.
          </Paragraph>
          <FadoelTable />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Paragraph fontSize="12px">
            Alle priser er uden pant. Panten varierer fra bryggeri til bryggeri,
            mellem 200 og 500 kr. Se fuld oversigt over{" "}
            <LinkStyled anchor to="/pant-og-returregler#pant-fustager">
              pantpriser på fuster
            </LinkStyled>
            .
            <br />
            Kulsyre medfølger gratis ved leje af anlæg og køb af ølfustager.
          </Paragraph>
          <Div textCenter>
            <LinkButton
              title="Online bestilling af fadøl og fadølsanlæg, levering eller selv hent, indtast mængder, adresse og dato, betal først efter festen"
              to="/bestil/fadoel-og-anlaeg"
              arrow
            >
              Bestil fadøl og fadølsanlæg online, betal senere
            </LinkButton>
          </Div>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={6} sm={3}>
          <LinkStyled
            block
            textCenter
            to="/fadoelsanlaeg"
            title="Fadølsanlæg bestående af fadølshane, køleanlæg og kulsyre"
          >
            <Image
              imageHeight="125px"
              name="packs.basis-3.png"
              title="Fadølsanlæg bestående af fadølshane, køleanlæg og kulsyre"
            />
            <br />
            <F12>Fadølsanlæg</F12>
          </LinkStyled>
        </Col>
        <Col xs={6} sm={3}>
          <LinkStyled
            block
            textCenter
            to="/fadoelsbar"
            title="Klapbar med fadølshane"
          >
            <Image
              imageHeight="125px"
              name="packs.fadoelsbar-skafte1.png"
              title="Klapbar med fadølshane"
            />
            <br />
            <F12>Klapbar</F12>
          </LinkStyled>
        </Col>
        <Col xs={6} sm={3}>
          <LinkStyled
            block
            textCenter
            to="/fadoelsbar/udskaenkningsvogn"
            title="Stor udskænkningsvogn"
          >
            <Image
              imageHeight="125px"
              name="packs.udskaenkningsvogn-160x90.png"
              title="Stor udskænkningsvogn"
            />
            <br />
            <F12>Udskænkningsvogn</F12>
          </LinkStyled>
        </Col>
        <Col xs={6} sm={3}>
          <LinkStyled block textCenter to="/fadoelsbar" title="Stilladsbar">
            <Image
              imageHeight="125px"
              name="packs.stilladsbar-160x112.png"
              title="Stilladsbar"
            />
            <br />
            <F12>Stilladsbar</F12>
          </LinkStyled>
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={6}>
          <Heading3>Leje af fadølsanlæg og bar</Heading3>
          <Paragraph>
            Lejeprisen for udstyr gælder helt op til 5 dage.
            <br />
            Vi har altid ledige anlæg, også med kort varsel.
          </Paragraph>
          <Table lines2>
            <thead>
              <Tr>
                <Th>Tappeudstyr, bar og plastglas</Th>
                <Th textRight>Pris</Th>
              </Tr>
            </thead>
            <tbody>
              <Tr>
                <Td>
                  Leje af&nbsp;
                  <LinkStyled to="/fadoelsanlaeg">fadølsanlæg</LinkStyled>&nbsp;
                  pr. hane&nbsp;
                  <Span fontSize="9px">(Op til 5 dage)</Span>
                </Td>
                <Td textRight>
                  <Price varenr={3607} noSuffix />
                </Td>
              </Tr>
              <Tr>
                <Td>
                  Leje af fadølsanlæg med 2 haner&nbsp;
                  <Span fontSize="9px">(Op til 5 dage)</Span>
                </Td>
                <Td textRight>
                  <Price varenr={3607} multiplier={2} noSuffix />
                </Td>
              </Tr>
              <Tr>
                <Td>
                  Leje af&nbsp;
                  <LinkStyled
                    title="Billede af Tuborg bardisk med tappehane og fadøl i plasticglas"
                    to="/fadoelsbar"
                  >
                    bardisk
                  </LinkStyled>
                  &nbsp; 120Bx60Dx100H
                </Td>
                <Td textRight>
                  <Price varenr={3906} noSuffix />
                </Td>
              </Tr>
              <Tr>
                <Td>
                  Leje af&nbsp;
                  <LinkStyled
                    title="Yderligere info om stiladsbar"
                    to="/fadoelsbar/stilladsbar"
                  >
                    stilladsbar
                  </LinkStyled>
                  &nbsp; 260Bx75Dx104H
                </Td>
                <Td textRight>
                  <Price varenr={3907} noSuffix />
                </Td>
              </Tr>
              <Tr>
                <Td>
                  Leje af&nbsp;
                  <LinkStyled
                    title="Billede af og mål for udskænkningsvogn"
                    to="/fadoelsbar/udskaenkningsvogn"
                  >
                    Udskænkningsvogn
                  </LinkStyled>
                  &nbsp; 4 haner
                </Td>
                <Td textRight>
                  <Price varenr={604} noSuffix />
                </Td>
              </Tr>
              <Tr>
                <Td>Leje af anlæg uden køb af øl uden kulsyre</Td>
                <Td textRight>
                  <PriceSum varenr={[3607, 603]} itemPrice noSuffix />
                </Td>
              </Tr>
              <Tr>
                <Td>
                  Plastik&nbsp;
                  <LinkStyled
                    title="Billede og beskrivelse af plasticglas"
                    to="/oelglas"
                  >
                    glas
                  </LinkStyled>
                  &nbsp;
                  <ColliCount varenr={7773} />
                  x33cl
                </Td>
                <Td textRight>
                  <Price varenr={7773} noSuffix />
                </Td>
              </Tr>
              <Tr>
                <Td>
                  Plastik&nbsp;
                  <LinkStyled
                    title="Billede og beskrivelse af plasticglas"
                    to="/oelglas"
                  >
                    glas
                  </LinkStyled>
                  &nbsp;
                  <ColliCount varenr={7774} />
                  x40cl
                </Td>
                <Td textRight>
                  <Price varenr={7774} noSuffix />
                </Td>
              </Tr>
            </tbody>
          </Table>
          <Paragraph fontSize="12px">
            Lejeprisen for tappeanlæg og andet udstyr gælder kun i forbindelse
            med køb af fadøl.
          </Paragraph>
        </Col>
        <Col xs={12} sm={6}>
          <Heading2>Priser på levering, opstilling og afhentning</Heading2>
          <Paragraph>
            Du kan sagtens selv montere fadølsanlægget. Se video om hvordan
            man&nbsp;
            <LinkStyled to="/fadoelsanlaeg/opsaetning-af-fadoelsanlaeg#opsaetning-af-fadoelsanlaeg">
              opstiller et fadølsanlæg
            </LinkStyled>
          </Paragraph>
          <Table lines2>
            <thead>
              <Tr>
                <Th colSpan={2}>Priser på levering og returtagning</Th>
                <Th textRight>Pris</Th>
              </Tr>
            </thead>
            <tbody>
              <Tr>
                <Td colSpan={2}>
                  Levering/retur og opsætning i alt&nbsp;
                  <Span fontSize="9px">(hverdage &amp; lørdage)</Span>
                </Td>
                <Td textRight>
                  <Price varenr={621} noSuffix />
                </Td>
              </Tr>
              <Tr>
                <Td colSpan={2}>
                  Levering/retur og opsætning i alt&nbsp;
                  <Span fontSize="9px">´ (Uge 48,49,50,51,52)</Span>
                </Td>
                <Td textRight>
                  <Price varenr={622} noSuffix />
                </Td>
              </Tr>
              <Tr>
                <Td colSpan={2}>Returtagning af ubrugt fustage</Td>
                <Td textRight>
                  <Price varenr={641} noSuffix />
                </Td>
              </Tr>
              <Tr>
                <Td colSpan={2}>Levering samme dag som bestilling tillægges</Td>
                <Td textRight>
                  <Price varenr={624} noSuffix />
                </Td>
              </Tr>
              <Tr>
                <Td colSpan={2}>Ekstra kørsel / forgæves kørsel</Td>
                <Td textRight>
                  <Price varenr={632} noSuffix />
                </Td>
              </Tr>
              <Tr>
                <Td colSpan={2}>
                  Tillæg for kørsel søndage og aften efter særlig aftale
                </Td>
                <Td textRight>
                  fra <Price varenr={623} noSuffix /> -{" "}
                  <Price varenr={628} noSuffix />
                </Td>
              </Tr>
              <Tr>
                <Th colSpan={2}>Priser hvis du selv har et fadølsanlæg</Th>
                <Th textRight>Pris</Th>
              </Tr>
              <Tr>
                <Td>
                  <LinkStyled to="/kulsyre">Kulsyre til eget anlæg</LinkStyled>
                  /fustager&nbsp;
                  <Span fontSize="10px">
                    Pant <Price embPrice varenr="8940" noSuffix />
                    ,-
                  </Span>
                </Td>
                <Td textRight>6 kg.</Td>
                <Td textRight>
                  <Price varenr="8940" noSuffix />
                </Td>
              </Tr>
              <Tr>
                <Td colSpan={2}>
                  <LinkStyled
                    title="Læs mere om rensedunke og rensevæske her!"
                    to="/reservedele/rensning-fadoelsanlaeg"
                  >
                    Rensedunk
                  </LinkStyled>
                </Td>
                <Td textRight>
                  <Price varenr={8975} noSuffix />
                </Td>
              </Tr>
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Paragraph>
            Prisliste til udskrivning&nbsp;
            <LinkStyled
              external
              to="/pdf/prisliste-fadoel.pdf"
              title="PDF fil med priser på fadøl og leje af fadølsanlæg"
            >
              prisliste til udskrivning (PDF)
            </LinkStyled>
          </Paragraph>
          <Paragraph>
            PDF dokument med&nbsp;
            <LinkStyled external to="/pdf/maal-vaegt-fadolsanlaeg.pdf">
              Mål, vægt, kølekapacitet og strømforbrug på tappeudstyr.
            </LinkStyled>
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading3>Bestil nemt dit fadøl online</Heading3>
          <LinkButton
            title="Bestil fadøl online og få leveret direkte til til din fest eller afhent selv og spar penge"
            to="/bestil/fadoel-og-anlaeg"
            arrow
          >
            Gå til online bestilling af fadøl og fadølanlæg til fest
          </LinkButton>
          <Paragraph marginTop="15px">
            Bestilling kan også foregå på telefon 43 27 00 00 alle hverdage 7-17
          </Paragraph>
          <Paragraph>
            Det med småt&nbsp;
            <LinkStyled
              title="Vilkår for leje af fadøl og køleanlæg"
              to="/levering-afhentning/vilkaar-fadoel"
            >
              leveringsvilkår for leje af fadølsanlæg og fadøl
            </LinkStyled>
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={6}>
          <Heading3>Afhent selv og spar leveringen</Heading3>
          <Paragraph>
            <Bold>Spar penge</Bold> - afhent selv anlæg og fustager direkte på
            vores lager i Brøndby. &nbsp;
            <LinkStyled
              title="Hvor og hvornår kan fadøl og køleanlæg afhentes"
              to="/levering-afhentning/afhentning"
            >
              Afhent fadøl og fadølsanlæg selv og spar leveringsprisen.
            </LinkStyled>
            &nbsp; Tryk på linket for at få yderligere oplysninger.
          </Paragraph>
        </Col>
        <Col xs={6} textCenter>
          <Image name="style.spar-levering-afhent-selv-fadoel.jpg" />
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Hvad bliver regningen på?</Heading2>
          <Row>
            <Col xs={12} md={6}>
              <Paragraph>
                <Bold>Eksempel 1:</Bold>&nbsp; Total pris på levering af 2
                fustager Du bestiller 4 fustager Grøn Tuborg fadøl samt
                fadølsanlæg og bar til levering. Der bliver brugt 2 fustager
                fadøl.
              </Paragraph>
              <Paragraph>Prisen bliver:</Paragraph>
              <Table lines2>
                <tbody>
                  <Tr>
                    <Td>Leje af tappeanlæg og kulsyre med 1 hane</Td>
                    <Td textRight>
                      <Price varenr={3607} noSuffix />
                      ,-
                    </Td>
                  </Tr>
                  <Tr>
                    <Td>Levering og afhentning i alt</Td>
                    <Td textRight>
                      <Price varenr={621} noSuffix />
                      ,-
                    </Td>
                  </Tr>
                  <Tr>
                    <Td>Fustager, Grøn Tuborg</Td>
                    <Td textRight>
                      2 x <Price varenr={3615} noSuffix />
                      ,-
                    </Td>
                  </Tr>
                  <Tr>
                    <Td>Returgebyr</Td>
                    <Td textRight>
                      2 x <Price varenr={641} noSuffix />
                      ,-
                    </Td>
                  </Tr>
                  <Tr>
                    <Td>Bardisk</Td>
                    <Td textRight>
                      <Price varenr={3906} noSuffix />
                      ,-
                    </Td>
                  </Tr>
                  <Tr>
                    <Td>I alt</Td>
                    <Td textRight>
                      <PriceSum
                        varenr={[3607, 621, [3615, 2], [641, 2], 3906]}
                        itemPrice
                      />
                    </Td>
                  </Tr>
                </tbody>
              </Table>
            </Col>
            <Col xs={12} md={6}>
              <Paragraph>
                <Bold>Eksempel 2:</Bold>&nbsp; Total pris på afhentning af 2
                fustager Du bestiller 5 fustager Grøn Tuborg fadøl samt
                fadølsanlæg til afhentning her hos os i Brøndby. Der bruges 2
                fustager fadøl.
              </Paragraph>
              <Paragraph>Prisen bliver:</Paragraph>
              <Table lines2>
                <tbody>
                  <Tr>
                    <Td>Leje af tappeanlæg og kulsyre med 1 hane</Td>
                    <Td textRight>
                      <Price varenr={3607} noSuffix />
                      ,-
                    </Td>
                  </Tr>
                  <Tr>
                    <Td>Øl</Td>
                    <Td textRight>
                      2 x <Price varenr={3615} noSuffix />
                      ,-
                    </Td>
                  </Tr>
                  <Tr>
                    <Td>Returgebyr</Td>
                    <Td textRight>
                      2 x <Price varenr={641} noSuffix />
                      ,-
                    </Td>
                  </Tr>
                  <Tr>
                    <Td>I alt</Td>
                    <Td textRight>
                      <PriceSum
                        varenr={[3607, [3615, 2], [641, 2]]}
                        itemPrice
                      />
                    </Td>
                  </Tr>
                </tbody>
              </Table>
            </Col>
            <Col xs={12}>
              <Paragraph fontSize="12px">
                Priserne er uden pant, med moms, betalingsbetingelser aftales
                individuelt. Offentlige virksomheder kan faktureres elektronisk
                vi EAN nummer. Returfustager eller kasser pålægges gebyr kr.{" "}
                <Price varenr={641} noSuffix /> pr. stk. Hastelevering samme dag
                tillægges kr. <Price varenr={624} noSuffix />. Forgæves kørsel
                pålægges gebyr kr. <Price varenr={632} noSuffix />. Kørsel på
                søndage efter aftale tillægges kr.{" "}
                <Price varenr={623} noSuffix />. Ret til ændringer uden varsel i
                priser, udvalg og betingelser forbeholdes. (Panten på ølfustager
                er kr. <Price varenr={3615} embPrice noSuffix /> /{" "}
                <Price varenr={8415} embPrice noSuffix />
                &nbsp; og på kulsyreflasker kr.{" "}
                <Price varenr={8940} embPrice noSuffix />. Den opkræves dog kun,
                hvis der ved returtagningen mangler fustager eller
                kulsyreflasker.) Lejepriserne forudsætter køb af fustager.
                ønskes kun leje af anlæg, er prisen kr.{" "}
                <Money money={73500} noSuffix />
                ,- uden kulsyre. På vores lager i Brøndby er det muligt at
                betale med Dankort, dette er ikke muligt når vi bringer ud. Vi
                udfører også fadølsservice.
              </Paragraph>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Dybdegående info om fadølsanlægs virkemåde og installation
          </Heading2>
          <LinkStyled external to="http://www.draughtquality.org/">
            Draughtmasterquality.org - Fadølsanlæg på restauranter og værtshuse.
          </LinkStyled>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} sm={6}>
          <Heading2>Fadølsservice fra Peter Skafte</Heading2>
          <Paragraph>
            1{" "}
            <LinkStyled to="/fustager-forklaring-vejledning">
              fustage fadøl
            </LinkStyled>{" "}
            = 25 liter = 75 almindelige flaske øl = 2½ kasse øl
          </Paragraph>
          <Image name="fadoel.oelbrik_med_forbrugsvejledning.gif" />
        </Col>
        <Col xs={12} sm={6}>
          <Heading2>Erfaringsmæssigt forbrug af sodavand til fester</Heading2>
          <Table lines2>
            <tbody>
              <Tr>
                <Td>Cola Cola</Td>
                <Td textRight>40%</Td>
              </Tr>
              <Tr>
                <Td>Cola light/Zero</Td>
                <Td textRight>10%</Td>
              </Tr>
              <Tr>
                <Td>Tuborg Squash, Fanta</Td>
                <Td textRight>15%</Td>
              </Tr>
              <Tr>
                <Td>Sprite, Faxe Kondi</Td>
                <Td textRight>15%</Td>
              </Tr>
              <Tr>
                <Td>Carlsberg Kurvand, Ramløse</Td>
                <Td textRight>10%</Td>
              </Tr>
              <Tr>
                <Td>Carlsberg Kurvand citrus, Ramløse citrus</Td>
                <Td textRight>5%</Td>
              </Tr>
              <Tr>
                <Td>Schweppes Lemon, Schweppes Tonic</Td>
                <Td textRight>5%</Td>
              </Tr>
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0">
          <Heading3>Flere priseksempler</Heading3>
          <Paragraph>
            Nem oversigt over hvad du skal betale i alt og pr. person for at
            købe fadøl og leje udstyr til festen. Vi har over 30 års erfaring i
            fadølsbranchen og har valgt at give 4 eksempler på forskellige
            arrangementer, for at give et nemt og hurtigt indblik i hvad der
            normalt bliver købt og drukket.
          </Paragraph>
          <Paragraph>
            Brug for hjælp eller et konkret tilbud? Ring på tlf. 43 27 00 00. Vi
            mailer dig gerne et tilbud tilpasset nøjagtig din fest.
          </Paragraph>
          <Paragraph>
            Se hvad andre kunder har drukket på siden{" "}
            <LinkStyled to="/forbrug-af-fadoel">
              &quot;Det drak andre kunder&quot;
            </LinkStyled>
            .
          </Paragraph>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Col xs={12} grey h100p>
            <Heading3>Reception (150 pers.)</Heading3>
            <Paragraph bold>
              *Passer også til bryllup (100 pers.) og familiefest (30-50 pers.)
            </Paragraph>
            <Table lines1>
              <tr>
                <Td colspan="4" bold>
                  150 genstande á 33cl
                </Td>
              </tr>
              <tr>
                <Td>2</Td>
                <Td>x</Td>
                <Td>Tuborg Classic 25 l</Td>
                <Td textRight>
                  <Price varenr="3655" multiplier={2} />
                </Td>
              </tr>
              <tr>
                <Td>1</Td>
                <Td>x</Td>
                <Td>Fadølsanlæg m. kulsyre</Td>
                <Td textRight>
                  <Price varenr="3607" />
                </Td>
              </tr>
              <tr>
                <Td>1</Td>
                <Td>x</Td>
                <Td>
                  30cl Glas, <ColliCount varenr="7773" /> stk. pr. rulle
                </Td>
                <Td textRight>
                  <Price varenr="7773" />
                </Td>
              </tr>
              <tr>
                <Td>1</Td>
                <Td>x</Td>
                <Td>Bar</Td>
                <Td textRight>
                  <Price varenr="3906" />
                </Td>
              </tr>
              <tr>
                <Td colspan="3">Levering og returtagning</Td>
                <Td textRight>
                  <Price varenr="621" />
                </Td>
              </tr>
              <tr>
                <Td colspan="3" bold>
                  I alt:
                </Td>
                <Td textRight bold>
                  <PriceSum
                    varenr={[[3655, 2], 3607, 7773, 3906, 621]}
                    itemPrice
                  />
                </Td>
              </tr>
              <tr>
                <Td colspan="3" bold>
                  Pris pr. 33cl glas:
                </Td>
                <Td textRight bold>
                  <PriceSum
                    varenr={[[3655, 2], 3607, 7773, 3906, 621]}
                    itemPrice
                    multiplier={1 / 150}
                  />
                </Td>
              </tr>
            </Table>
          </Col>
        </Col>
        <Col xs={12} md={6}>
          <Col xs={12} grey h100p>
            <Heading3>Firmafest fri bar (50 - 100 pers.)</Heading3>
            <Paragraph bold>
              *Passer også til ungdomsfest (30-50 pers.)
            </Paragraph>
            <Table lines1>
              <tr>
                <Td colspan="4" bold>
                  300 genstande á 33cl
                </Td>
              </tr>
              <tr>
                <Td>2</Td>
                <Td>x</Td>
                <Td>Tuborg Classic 25 l</Td>
                <Td textRight>
                  <Price varenr="3655" multiplier={2} />
                </Td>
              </tr>
              <tr>
                <Td>2</Td>
                <Td>x</Td>
                <Td>Grøn Tuborg 25 l</Td>
                <Td textRight>
                  <Price varenr="3615" multiplier={2} />
                </Td>
              </tr>
              <tr>
                <Td>1</Td>
                <Td>x</Td>
                <Td>Fadølsanlæg, 2 haner m. kulsyre</Td>
                <Td textRight>
                  <Price varenr="3608" />
                </Td>
              </tr>
              <tr>
                <Td>3</Td>
                <Td>x</Td>
                <Td>
                  30cl Glas, <ColliCount varenr="7773" /> stk. pr. rulle
                </Td>
                <Td textRight>
                  <Price varenr="7773" multiplier={3} />
                </Td>
              </tr>
              <tr>
                <Td>1</Td>
                <Td>x</Td>
                <Td>Bar</Td>
                <Td textRight>
                  <Price varenr="3906" />
                </Td>
              </tr>
              <tr>
                <Td colspan="3">Levering og returtagning</Td>
                <Td textRight>
                  <Price varenr="621" />
                </Td>
              </tr>
              <tr>
                <Td colspan="3" bold>
                  I alt:
                </Td>
                <Td textRight bold>
                  <PriceSum
                    varenr={[[3655, 2], [3615, 2], 3608, [7773, 3], 3906, 621]}
                    itemPrice
                  />
                </Td>
              </tr>
              <tr>
                <Td colspan="3" bold>
                  Pris pr. 33cl glas:
                </Td>
                <Td textRight bold>
                  <PriceSum
                    varenr={[[3655, 2], [3615, 2], 3608, [7773, 3], 3906, 621]}
                    itemPrice
                    multiplier={1 / 300}
                  />
                </Td>
              </tr>
            </Table>
          </Col>
        </Col>
        <Col xs={12} md={6}>
          <Col xs={12} grey h100p>
            <Heading3>Svendegilde (100 pers.)</Heading3>
            <Paragraph bold>*Gælder også drukfest/abefest</Paragraph>
            <Table lines1>
              <tr>
                <Td colspan="4" bold>
                  630 genstande á 33cl
                </Td>
              </tr>
              <tr>
                <Td>7</Td>
                <Td>x</Td>
                <Td>Platan Pilsner 30 l</Td>
                <Td textRight>
                  <Price varenr="8415" multiplier={7} />
                </Td>
              </tr>
              <tr>
                <Td>1</Td>
                <Td>x</Td>
                <Td>Fadølsanlæg m. kulsyre</Td>
                <Td textRight>
                  <Price varenr="3607" />
                </Td>
              </tr>
              <tr>
                <Td colspan="3">Levering og returtagning</Td>
                <Td textRight>
                  <Price varenr="621" />
                </Td>
              </tr>
              <tr>
                <Td colspan="3" bold>
                  I alt:
                </Td>
                <Td textRight bold>
                  <PriceSum varenr={[[8415, 7], 3607, 621]} itemPrice />
                </Td>
              </tr>
              <tr>
                <Td colspan="3" bold>
                  Pris pr. 33cl glas:
                </Td>
                <Td textRight bold>
                  <PriceSum
                    varenr={[[8415, 7], 3607, 621]}
                    itemPrice
                    multiplier={1 / 630}
                  />
                </Td>
              </tr>
            </Table>
          </Col>
        </Col>
        <Col xs={12} md={6}>
          <Col xs={12} grey h100p>
            <Heading3>Stor fest m. salg af fadøl (350 - 550 pers.)</Heading3>
            <Paragraph bold>
              *Passer også til julefrokost m. gratis fadøl (200-300 pers.)
            </Paragraph>
            <Table lines1>
              <tr>
                <Td colspan="4" bold>
                  1350 genstande á 33cl
                </Td>
              </tr>
              <tr>
                <Td>15</Td>
                <Td>x</Td>
                <Td>Skovlyst Birkebryg Pilsner 30l</Td>
                <Td textRight>
                  <Price varenr="8215" multiplier={15} />
                </Td>
              </tr>
              <tr>
                <Td>1</Td>
                <Td>x</Td>
                <Td>Fadølsanlæg, 2 haner m. kulsyre</Td>
                <Td textRight>
                  <Price varenr="3608" />
                </Td>
              </tr>
              <tr>
                <Td>15</Td>
                <Td>x</Td>
                <Td>
                  30cl Glas, <ColliCount varenr="7773" /> stk. pr. rulle
                </Td>
                <Td textRight>
                  <Price varenr="7773" multiplier={15} />
                </Td>
              </tr>
              <tr>
                <Td>1</Td>
                <Td>x</Td>
                <Td>Bar</Td>
                <Td textRight>
                  <Price varenr="3906" />
                </Td>
              </tr>
              <tr>
                <Td colspan="3">Levering og returtagning</Td>
                <Td textRight>
                  <Price varenr="621" />
                </Td>
              </tr>
              <tr>
                <Td colspan="3" bold>
                  I alt:
                </Td>
                <Td textRight bold>
                  <PriceSum
                    varenr={[[8215, 15], 3608, [7773, 15], 3906, 621]}
                    itemPrice
                  />
                </Td>
              </tr>
              <tr>
                <Td colspan="3" bold>
                  Pris pr. 33cl glas:
                </Td>
                <Td textRight bold>
                  <PriceSum
                    varenr={[[8215, 15], 3608, [7773, 15], 3906, 621]}
                    itemPrice
                    multiplier={1 / 1350}
                  />
                </Td>
              </tr>
            </Table>
          </Col>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading3>Fadøl priser - få det fulde overblik her</Heading3>
          <Paragraph>
            Hos Skafte er du garanteret skarpe priser på både fadøl og leje af
            fadølsanlæg - hver eneste gang.
          </Paragraph>
          <Paragraph>
            Her på siden kan du danne dig det fulde overblik over alle vores
            fadøl priser samt priser for leje af fadølsanlæg. Vi har gjort det
            overskueligt at finde prisen på nøjagtigt det, som du har brug for.
            Det betyder, at vi har opdelt efter kategori, så du således kan
            finde:
          </Paragraph>
          <List>
            <li>Fadøl fustage pris</li>
            <li>Drinks fustage pris</li>
            <li>Leje af fadølsanlæg pris</li>
            <li>Opstillings-, leverings- og afhentningspris</li>
          </List>
          <Paragraph>
            Fester, arrangementer og andre større begivenheder kalder på frisk
            skænkede fadøl helt af sig selv og hos os finder du heldigvis alt
            hvad du skal bruge. Det betyder, at du finder alt lige fra
            fadølsanlæg, haner, barborde, vogne og glas. Du finder naturligvis
            også en masse skøn og forfriskende øl i flere varianter, hvor der er
            noget for enhver smag. Find bl.a. både pilsner, special øl, IPA,
            mørk øl, alkoholfri øl og meget, meget mere.
          </Paragraph>
          <Paragraph>
            Har du brug for hjælp til at opstille fadølsanlægget samt tage det
            ned igen, klarer vi gerne dette med et smil. Vi tager også gerne
            ubrugte fustager retur mod et mindre gebyr.
          </Paragraph>
          <Paragraph>
            Vores fadøl priser er altid til at forstå. Her på siden kan du få et
            overblik over literpris for hver enkelte øl. Dette gør det lettere
            for dig at gennemskue hvor mange penge du egentlig giver for øllen,
            når fustagerne findes i forskellig størrelse. Vores fadøl sælges i
            producentens egne fustager, hvilket betyder, at der ikke er tale om
            samme mængde øl og du finder derfor fustager med enten 10 liter, 15
            liter, 20 liter, 35 liter eller 30 liter.
          </Paragraph>
          <Paragraph>
            Udover skarpe priser på øl og fadølsanlæg, så leverer vi naturligvis
            også både vin, cider, drinks og cocktails på fad, så du har mulighed
            for at servere noget for enhver smag, hvis øl ikke er sagen. Se
            vores store udvalg under kategorien “fustager” og lad dig inspirere
            til din næste fest.
          </Paragraph>
          <Heading3>Hvad koster det at leje et fadølsanlæg?</Heading3>
          <Paragraph>
            Alle skal have råd til at kunne leje et fadølsanlæg og derfor har vi
            altid super skarpe priser, som alle kan være med på. Her på siden
            får du det fulde overblik over priserne på leje af fadølsanlæg, så
            du let kan sammenligne og finde den bedste løsning til din næste
            fest eller arrangement.
          </Paragraph>
          <Paragraph>Find priserne på:</Paragraph>
          <List>
            <li>Leje af fadølshane</li>
            <li>Leje af to fadølshaner</li>
            <li>Leje af bardisk</li>
            <li>Leje af stilladsbar</li>
            <li>Leje af udskænkningsvogn med fire fadølshaner</li>
            <li>Prisen på leje af fadølsanlæg uden køb af øl</li>
            <li>Prisen på plastik glas til brug til festen</li>
          </List>
          <Paragraph>
            Når du vælger at leje en eller flere fadølshaner, bør du være
            opmærksom på at disse skal sættes fast på eget bord, for at anlægget
            kan fungere. Har du ikke et passende bord eller plads nok, kan du
            med fordel vælge at leje en bardisk eller stilladsbar i samme
            omgang. På denne måde er du sikret, at der er plads til hanerne.
          </Paragraph>
          <Paragraph>
            Vi sørger for at holde priserne nede, så du og dine gæster kan have
            en god fest eller arrangement, hvor der ikke mangler noget. Derfor
            finder du også en fadølsanlægs pris helt ned til{" "}
            <Price varenr="pack_1" />
          </Paragraph>
          <Heading3>Billige priser på fadøl</Heading3>
          <Paragraph>
            Vi har altid skarpe fadøl priser. Hos Skafte finder du et kæmpe
            udvalg af både øl, vin, drinks og cocktails på fad, så du har
            mulighed for at vælge det, der vil falde bedst i både din og dines
            gæsters smag.
          </Paragraph>
          <Paragraph>
            Vores øl fustage priser starter helt nede fra 425 kr. for en 20
            liters fustage, hvilket er en skarp literpris på kun 21,25 kr.
          </Paragraph>
          <Paragraph>
            Er du i tvivl om hvor meget du skal bestille? Selvom vi har
            konkurrencedygtige og billige priser på på fadøl, så kan det være
            rart at kunne bestille den rette mængde og det kan være svært at
            vide, hvor meget en enkelt fustage svarer til. En fustage fadøl på
            25 liter er det samme som 75 almindelige flaske øl, hvilket svarer
            til 2,5 kasser øl.
          </Paragraph>
          <Paragraph>
            Har du spørgsmål eller har du brug for hjælp i forbindelse med din
            bestilling af øl og leje af fadølsanlæg, er du altid velkommen til
            at kontakte os på tlf. 4327 0000 eller mail peter@skafte.dk. Vi
            sidder klar til at hjælpe dig godt på vej.
          </Paragraph>
          <Heading3>
            Altid ledige fadølsanlæg og skarpe fadøl priser hos Skafte
          </Heading3>
          <Paragraph>
            Hos Skafte finder du altid ledige fadølsanlæg - også selvom du
            bestiller med kort varsel. Du bør nemlig aldrig være begrænset, når
            du skal stable en fest eller et arrangement på benene.
          </Paragraph>
          <Paragraph>
            Du kan således enten vælge at bestille et fadølsanlæg lang tid før
            festen eller med kun få dages varsel. Vi kan endda sørge for
            levering samme dag mod et gebyr. Vær dog opmærksom på at nogle
            fustager har længere leveringstid, da de skal leveres fra et
            fjernlager. Dette er altid angivet ved de pågældende varianter.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
